import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Orange_Media',
    component: () => import('@/views/index'),
    children:[
      {
        path: '/',
        name: 'Company',
        component: () => import('@/views/company'),
        meta: {
          pagebelong:'company',
        }
      },
      {
        path: '/Apps',
        name: 'Apps',
        component: () => import('@/views/apps'),
        meta: {
          pagebelong:'app',
        }
      },
      {
        path: '/ContactUs',
        name: 'Contact_Us',
        component: () => import('@/views/contactUs'),
        meta: {
          pagebelong:'contact',
        }
      },
      {
        path: '/AppDetails',
        name: 'App_Details',
        component: () => import('@/views/appDetail'),
        meta: {
          pagebelong:'app'
        }
      }
    ]
  },
  {
    path: '/Privacy_Policy',
    name: 'Privacy_Policy',
    component: () => import('@/views/privacy'),
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log(savedPosition)
    if(savedPosition) {
        return savedPosition
    } else {
        return {
            x: 0,
            y: 0
        }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta && to.meta.metaInfo) {
    store.commit("CAHNGE_META_INFO", to.meta.metaInfo);
    // const metaInfo = to.meta.metaInfo.map(tag => {
    //   const attrs = Object.keys(tag).reduce((acc, key) => {
    //     acc[key] = { content: tag[key] };
    //     return acc;
    //   }, {});
    //   return {
    //     ...tag,
    //     ...attrs
    //   };
    // });
    // // 清除旧的meta标签
    // const head = document.getElementsByTagName('head')[0];
    // const oldMeta = document.querySelectorAll('meta[data-vue-router-meta]');
    // oldMeta.forEach(meta => head.removeChild(meta));
    // // 添加新的meta标签
    // metaInfo.forEach(tag => {
    //   const meta = document.createElement('meta');
    //   Object.keys(tag).forEach(key => {
    //     meta.setAttribute(key, tag[key].content);
    //   });
    //   meta.setAttribute('data-vue-router-meta', true);
    //   head.appendChild(meta);
    // });
  }
  next();
});

export default router
